
export function TestimonialsSection() {
  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-16 space-y-3 sm:space-y-4">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900">Prueba Social</h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 leading-relaxed">
            Únete a cientos de emprendedores que ya están facturando con productos digitales en nuestra comunidad de Skool
          </p>
        </div>

        <div className="max-w-6xl mx-auto mb-8 sm:mb-12">
          <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl">
            <img
              alt="Prueba social de resultados reales"
              className="w-full h-auto object-cover object-top"
              src="https://static.readdy.ai/image/3e793795e87845ada69b8088167d8f30/903a8986b0c37e0552001f40094effd5.png"
            />
          </div>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-emerald-50 to-cyan-50 rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-12 border-2 border-emerald-200 shadow-xl">
            <div className="text-center space-y-4 sm:space-y-6">
              <div className="flex justify-center gap-1 sm:gap-2">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-yellow-400 text-2xl sm:text-3xl lg:text-4xl"></i>
                ))}
              </div>
              
              <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900">
                Más de 500 estudiantes activos
              </h3>
              
              <p className="text-sm sm:text-base lg:text-lg text-gray-700 leading-relaxed max-w-2xl mx-auto">
                Nuestra comunidad está llena de emprendedores que están implementando estas estrategias 
                y generando resultados reales. Comparten sus avances, se apoyan mutuamente y celebran 
                sus victorias juntos.
              </p>

              <div className="grid grid-cols-3 gap-3 sm:gap-4 lg:gap-6 pt-4 sm:pt-6">
                <div className="text-center p-3 sm:p-4 lg:p-6 bg-white rounded-xl sm:rounded-2xl shadow-md">
                  <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-emerald-600 mb-1 sm:mb-2">500+</div>
                  <div className="text-xs sm:text-sm lg:text-base text-gray-600 font-medium">Estudiantes</div>
                </div>
                <div className="text-center p-3 sm:p-4 lg:p-6 bg-white rounded-xl sm:rounded-2xl shadow-md">
                  <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-emerald-600 mb-1 sm:mb-2">4.9</div>
                  <div className="text-xs sm:text-sm lg:text-base text-gray-600 font-medium">Rating</div>
                </div>
                <div className="text-center p-3 sm:p-4 lg:p-6 bg-white rounded-xl sm:rounded-2xl shadow-md">
                  <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-emerald-600 mb-1 sm:mb-2">100%</div>
                  <div className="text-xs sm:text-sm lg:text-base text-gray-600 font-medium">Satisfacción</div>
                </div>
              </div>

              <div className="pt-4 sm:pt-6">
                <button
                  onClick={() => {
                    const checkoutSection = document.getElementById('checkout');
                    if (checkoutSection) {
                      checkoutSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                  }}
                  className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 rounded-lg sm:rounded-xl font-bold text-sm sm:text-base lg:text-lg bg-gradient-to-r from-emerald-500 to-cyan-500 text-white hover:shadow-2xl hover:shadow-emerald-500/50 transition-all hover:scale-105 whitespace-nowrap cursor-pointer inline-block"
                >
                  Únete a la Comunidad Ahora →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
